import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Invoice } from '../models/invoice';
import { InvoiceLine } from '../models/invoice-line';
import { Paginated } from '../models/paginated';
import { InvoicesService } from './services/invoices.service';
import { InvoiceFilter } from '../models/invoice-filter';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { MessageService } from 'primeng/components/common/messageservice';
import {Http, Response, RequestOptions, Headers, HttpModule} from '@angular/http';
import {WeekInvoices} from './invoice-week-selector/invoice-week-table/invoice-week-table.component';

@Component({
	selector: 'app-invoices',
	templateUrl: 'invoices.template.html'
})

/**
 * Component that displays the invoices page
 */
export class InvoicesComponent implements OnInit
{
	selectedInvoices = [];
	weekInvoices: Paginated<Invoice[]>;
	invoices_count: WeekInvoices[];
	currentFilter: InvoiceFilter;
	currentWeek = moment().isoWeek();

	/**
	 * InvoicesComponent constructor
	 *
	 * @param {ActivatedRoute} route
	 * @param {InvoicesService} invoicesService
	 * @param {MessageService} messageService
	 */
	constructor(private route: ActivatedRoute, private invoicesService: InvoicesService, private messageService: MessageService, private http: Http)
	{
		let invoiceFilter = JSON.parse( localStorage.getItem('invoiceFilter') );

		if( invoiceFilter != null ) {
			this.currentFilter = invoiceFilter;
		} else {
			this.currentFilter = {
				year: moment().year(),
				week: moment().isoWeek(),
				search: null
			};
		}

		if (localStorage.getItem('keepSearchFilter') != null) {
		  localStorage.removeItem('keepSearchFilter');
    } else {
		  this.currentFilter.search = null;
    }
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of this component are
	 * initialized.
	 */
	ngOnInit()
	{
		this.route.data.subscribe(
			(data: { weekInvoices: Paginated<Invoice[]>, invoices_count: WeekInvoices[] }) => {
				this.weekInvoices = data.weekInvoices;
				this.invoices_count = data.invoices_count;
			}
		);
	}


	public updateSearchInvoice(invoiceFilter: InvoiceFilter, page = 1)
	{
		invoiceFilter = {
			year: this.currentFilter.year,
			week: this.currentFilter.week,
			search: invoiceFilter.search === '' ? null : invoiceFilter.search
		};

		localStorage.setItem('invoiceFilter', JSON.stringify( invoiceFilter ) );

		if (page >= 1 && this.weekInvoices.meta.pagination.total_pages === 0 || page <= this.weekInvoices.meta.pagination.total_pages) {
			this.currentFilter = invoiceFilter;

			this.invoicesService.getPaginatedInvoices(page, invoiceFilter).subscribe(
				data => {
					if (data.meta && data.meta.pagination.total > 0) {
						this.weekInvoices = data;
					}
					else {
						//this.weekInvoices = new Paginated();
					}
				}
			);
		}
	}

	public updateWeekNumberInvoices(invoiceFilter: InvoiceFilter, page = 1)
	{
		invoiceFilter.search = null;

		this.updateWeekInvoices(invoiceFilter, page);
	}

	/**
	 * Updates the selected collection of invoices for a given filter
	 *
	 * @param {InvoiceFilter} invoiceFilter
	 * @param {number} page
	 *
	 * @returns void
	 */
	public updateWeekInvoices(invoiceFilter: InvoiceFilter, page = 1)
	{
		invoiceFilter = {
			year: this.currentFilter.year,
			week: invoiceFilter.week,
			search: invoiceFilter.search
		};

		localStorage.setItem('invoiceFilter', JSON.stringify( invoiceFilter ) );

		if (page >= 1 && this.weekInvoices.meta.pagination.total_pages === 0 || page <= this.weekInvoices.meta.pagination.total_pages) {
			this.currentFilter = invoiceFilter;

			this.invoicesService.getPaginatedInvoices(page, invoiceFilter).subscribe(
				data => {

					//this.selectedInvoices = [];

					if (data.meta && data.meta.pagination.total > 0) {
						this.weekInvoices = data;
					}
					else {
						//this.weekInvoices = new Paginated();
					}
				}
			);
		}
	}

	/**
	 * sums invoice total (incl. tax)
	 *
	 * @returns double
	 */
	public calcInvoiceTotal(invoice: Invoice)
	{
		var total = 0;
    var totalVat = 0;
	    for(var i = 0; i < invoice.invoiceLines.length; i++){
	        total += invoice.invoiceLines[i].price_ex_vat;
          totalVat += invoice.invoiceLines[i].price_ex_vat * invoice.invoiceLines[i].vat_percentage / 100;
	    }

      var totalInc = total + totalVat;
	    return totalInc;
	}

	/**
	 * Updates the collection of invoices used in the week selector
	 *
	 * @returns void
	 */
	public updateWeekSelectorInvoices()
	{
    this.invoicesService.getInvoicesCounts(this.currentFilter.year).subscribe(
      data => {
        this.invoices_count = data;
      }
    )
	}

	/**
	 * Ajax request for downloading the XML ubl file for the given invoices
	 *
	 * @param {Array<number>} invoiceIds
	 *
	 * @returns void
	 */
	public exportUBLXML(invoiceIds: Array<number>)
	{
		const params = [];

		invoiceIds.forEach(id => {
			params.push('invoices[]=' + id);
		});

		this.invoicesService.getInvoiceUBL(params).then((data: any) =>
		{
			invoiceIds.forEach(invoiceId => {
				const blob: Blob = new Blob([data.invoices[invoiceId]]);
				const a = document.createElement('a');
				a.setAttribute('style', 'display:none;');
				document.body.appendChild(a);
				a.href = window.URL.createObjectURL(blob);
				a.download = invoiceId+"_ubl.xml";
				a.click();
			});
		});

	}

	/**
	 * Opens a new window with a stream of xml files given for the selected accountancy program
	 *
	 * @returns void
	 */
	public exportAccountancy()
	{
		const params = [];
		params.push('year='+this.currentFilter.year);
		params.push('week='+this.currentFilter.week);

		this.invoicesService.getAccountancyExport(params).then((data: any) =>
		{
				const blob: Blob = new Blob([data.invoices]);
				const a = document.createElement('a');
				a.setAttribute('style', 'display:none;');
				document.body.appendChild(a);
				a.href = window.URL.createObjectURL(blob);
				a.download = "accountancy_export_week_"+this.currentFilter.year+this.currentFilter.week+".xml";
				a.click();
		});

	}

	/**
	 * Opens a new window with a stream of xml files given for the selected accountancy program
	 *
	 * @returns void
	 */
	public pdfAccountancy()
	{
		const params = [];
		params.push('year='+this.currentFilter.year);
		params.push('week='+this.currentFilter.week);

		window.open(environment.api_url + 'invoices/export/list?' + params.join('&') );
	}

	/**
	 * Opens a new window with a stream of the pdf for the given invoice
	 *
	 * @param {Array<number>} invoiceIds
	 * @param {boolean} proforma
	 *
	 * @returns void
	 */
	public exportInvoices(invoiceIds: Array<number>, proforma = false)
	{
		const params = [];

		invoiceIds.forEach(id => {
			params.push('invoices[]=' + id);
		});

		if (proforma) {
			params.push('type=proforma');
		}

		window.open(environment.api_url + 'invoices/export?' + params.join('&'))
	}

	/**
	 * Sends the selected invoices to the invoices' customers
	 *
	 * @param {Array<number>} invoiceIds
	 * @param {boolean} proforma
	 *
	 * @returns void
	 */
	public sendInvoices(invoiceIds: Array<number>, proforma = false)
	{
		const params = [];

		invoiceIds.forEach(id => {
			params.push('invoices[]=' + id);
		});

		if (proforma) {
			params.push('type=proforma');
		}

		this.invoicesService.sendInvoices(params).subscribe(
			data => {
				// Update invoice table and week selector data
				this.updateWeekSelectorInvoices();
				this.updateWeekInvoices(this.currentFilter, this.weekInvoices.meta.pagination.current_page);

				// Show success message
				this.messageService.add({
					summary: 'Succes',
					detail: 'De facturen zijn verzonden.',
					severity: 'success'
				});
			},
			err => {
				// Show error message
				this.messageService.add({
					summary: 'Fout',
					detail: 'Er is een fout opgetreden bij het versturen van een factuur.',
					severity: 'error'
				});
			}
		);
	}

	/**
	 * Toggles the selection of all invoices
	 *
	 * @returns void
	 */
	public selectAllInvoices(event)
	{

		this.selectedInvoices = [];

		if( event.target.checked )
		{

			let invoiceFilterTemp = {
				year: this.currentFilter.year,
				week: this.currentFilter.week,
				search: null
			};

			this.invoicesService.getPaginatedInvoices(null, invoiceFilterTemp).subscribe(
				data => {

					data.data.forEach(invoice => {
						this.selectedInvoices.push(invoice['id']);
					});

				}
			);
		}
	}

	/**
	 * Toggles the selection of an invoice
	 *
	 * @param {number} id
	 *
	 * @returns void
	 */
	public selectInvoice(id: number)
	{
		if (this.selectedInvoices.indexOf(id) === -1) {
			this.selectedInvoices.push(id);
		}
		else {
			this.selectedInvoices.splice(this.selectedInvoices.indexOf(id), 1);
		}
	}

	public setSelectedYear(year: number)
  {
    this.currentFilter.year = year;
  }
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoices.component.ts